import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

if (process.env.NODE_ENV !== 'test') {
  ReactModal.setAppElement('#root');
}

interface Props extends Omit<ReactModal['props'], 'portalClassName' | 'isOpen' | 'contentLabel'> {
  open: boolean;
  label?: string;
  className?: string;
  modalClassName?: string;
}

const BaseModal = ({ className, modalClassName, open, label, ...rest }: Props) => {
  const [contentElement, setContentElement] = useState<HTMLElement>();

  useEffect(() => {
    if (contentElement) {
      disableBodyScroll(contentElement);
    }

    return () => contentElement && enableBodyScroll(contentElement);
  }, [contentElement]);

  return (
    <ReactModal
      portalClassName={className}
      className={modalClassName}
      overlayRef={setContentElement}
      contentLabel={label}
      isOpen={open}
      {...rest}
    />
  );
};

export default BaseModal;
